export const hardcodedDashboardOptions = {
  genres: [
    {
      id: 1,
      name: "Adult Contemporary (Singer/Songwriter)",
      parent: null,
      children: [],
    },
    {
      id: 2,
      name: "Audio Books",
      parent: null,
      children: [],
    },
    {
      id: 3,
      name: "Blues",
      parent: null,
      children: [
        {
          id: 168,
          name: "Blues (Contemporary)",
          mapping_id: null,
        },
        {
          id: 27,
          name: "Blues (Traditional)",
          mapping_id: null,
        },
      ],
    },
    {
      id: 4,
      name: "Children's Music",
      parent: null,
      children: [],
    },
    {
      id: 5,
      name: "Christian",
      parent: null,
      children: [
        {
          id: 28,
          name: "Christian Pop",
          mapping_id: null,
        },
        {
          id: 29,
          name: "Christian Rap/Hip-Hop",
          mapping_id: null,
        },
        {
          id: 30,
          name: "Christian Rock",
          mapping_id: null,
        },
        {
          id: 31,
          name: "Gospel",
          mapping_id: null,
        },
        {
          id: 32,
          name: "Religious",
          mapping_id: null,
        },
      ],
    },
    {
      id: 6,
      name: "Classical",
      parent: null,
      children: [
        {
          id: 33,
          name: "Baroque",
          mapping_id: null,
        },
        {
          id: 34,
          name: "Classical Guitar",
          mapping_id: null,
        },
        {
          id: 35,
          name: "Contemporary Classical",
          mapping_id: null,
        },
        {
          id: 36,
          name: "Modern Classical",
          mapping_id: null,
        },
        {
          id: 37,
          name: "Opera",
          mapping_id: null,
        },
        {
          id: 38,
          name: "Piano Classical",
          mapping_id: null,
        },
      ],
    },
    {
      id: 7,
      name: "Comedy",
      parent: null,
      children: [],
    },
    {
      id: 10,
      name: "Electronic",
      parent: null,
      children: [
        {
          id: 45,
          name: "2 Step",
          mapping_id: null,
        },
        {
          id: 46,
          name: "Acid House",
          mapping_id: null,
        },
        {
          id: 47,
          name: "Ambient",
          mapping_id: null,
        },
        {
          id: 48,
          name: "Beats & Breaks",
          mapping_id: null,
        },
        {
          id: 49,
          name: "Breaks",
          mapping_id: null,
        },
        {
          id: 50,
          name: "Broken Beat",
          mapping_id: null,
        },
        {
          id: 52,
          name: "Deep House",
          mapping_id: null,
        },
        {
          id: 53,
          name: "Disco",
          mapping_id: null,
        },
        {
          id: 54,
          name: "Downtempo",
          mapping_id: null,
        },
        {
          id: 55,
          name: "Drum & Bass",
          mapping_id: null,
        },
        {
          id: 56,
          name: "Electro House",
          mapping_id: null,
        },
        {
          id: 57,
          name: "Electronic Lounge",
          mapping_id: null,
        },
        {
          id: 58,
          name: "Electronica",
          mapping_id: null,
        },
        {
          id: 59,
          name: "Experimental",
          mapping_id: null,
        },
        {
          id: 60,
          name: "Funky Breaks",
          mapping_id: null,
        },
        {
          id: 61,
          name: "Funky House",
          mapping_id: null,
        },
        {
          id: 62,
          name: "Garage",
          mapping_id: null,
        },
        {
          id: 215,
          name: "Garage / Bassline / Grime",
          mapping_id: null,
        },
        {
          id: 63,
          name: "Glitch",
          mapping_id: null,
        },
        {
          id: 64,
          name: "Hard House",
          mapping_id: null,
        },
        {
          id: 65,
          name: "House",
          mapping_id: null,
        },
        {
          id: 66,
          name: "Leftfield/IDM",
          mapping_id: null,
        },
        {
          id: 67,
          name: "Miami Bass",
          mapping_id: null,
        },
        {
          id: 68,
          name: "Minimal Techno",
          mapping_id: null,
        },
        {
          id: 69,
          name: "Nu Skool Breaks",
          mapping_id: null,
        },
        {
          id: 70,
          name: "Progressive House",
          mapping_id: null,
        },
        {
          id: 71,
          name: "Progressive Trance",
          mapping_id: null,
        },
        {
          id: 72,
          name: "Psy Trance",
          mapping_id: null,
        },
        {
          id: 73,
          name: "Tech House",
          mapping_id: null,
        },
        {
          id: 74,
          name: "Techno",
          mapping_id: null,
        },
        {
          id: 75,
          name: "Trance",
          mapping_id: null,
        },
        {
          id: 212,
          name: "Trap / Future Bass",
          mapping_id: null,
        },
        {
          id: 76,
          name: "Tribal House",
          mapping_id: null,
        },
        {
          id: 77,
          name: "Trip Hop",
          mapping_id: null,
        },
      ],
    },
    {
      id: 11,
      name: "Folk",
      parent: null,
      children: [
        {
          id: 79,
          name: "Folk (Singer/Songwriter)",
          mapping_id: null,
        },
        {
          id: 78,
          name: "Trip Hop",
          mapping_id: null,
        },
      ],
    },
    {
      id: 12,
      name: "Holiday Music",
      parent: null,
      children: [],
    },
    {
      id: 16,
      name: "Jazz",
      parent: null,
      children: [
        {
          id: 82,
          name: "Acid Jazz",
          mapping_id: null,
        },
        {
          id: 83,
          name: "Big Band",
          mapping_id: null,
        },
        {
          id: 84,
          name: "Bossa Nova",
          mapping_id: null,
        },
        {
          id: 85,
          name: "Jazz (Contemporary)",
          mapping_id: null,
        },
        {
          id: 86,
          name: "Jazz (Traditional)",
          mapping_id: null,
        },
        {
          id: 87,
          name: "Latin Jazz",
          mapping_id: null,
        },
        {
          id: 88,
          name: "Swing",
          mapping_id: null,
        },
        {
          id: 89,
          name: "Vocal Jazz",
          mapping_id: null,
        },
      ],
    },
    {
      id: 17,
      name: "Latin",
      parent: null,
      children: [
        {
          id: 175,
          name: "Alternative",
          mapping_id: null,
        },
        {
          id: 90,
          name: "Bachata",
          mapping_id: null,
        },
        {
          id: 176,
          name: "Hip Hop / Rap",
          mapping_id: null,
        },
        {
          id: 178,
          name: "Latin Jazz",
          mapping_id: null,
        },
        {
          id: 91,
          name: "Latin Pop",
          mapping_id: null,
        },
        {
          id: 92,
          name: "Mambo",
          mapping_id: null,
        },
        {
          id: 93,
          name: "Mariachi",
          mapping_id: null,
        },
        {
          id: 94,
          name: "Mexican",
          mapping_id: null,
        },
        {
          id: 95,
          name: "Ranchera, Merengue",
          mapping_id: null,
        },
        {
          id: 177,
          name: "Reggaeton",
          mapping_id: null,
        },
        {
          id: 96,
          name: "Salsa",
          mapping_id: null,
        },
        {
          id: 97,
          name: "Samba",
          mapping_id: null,
        },
        {
          id: 98,
          name: "Tango",
          mapping_id: null,
        },
      ],
    },
    {
      id: 18,
      name: "Oldies",
      parent: null,
      children: [
        {
          id: 99,
          name: "50's",
          mapping_id: null,
        },
        {
          id: 100,
          name: "60's",
          mapping_id: null,
        },
        {
          id: 101,
          name: "70's",
          mapping_id: null,
        },
        {
          id: 102,
          name: "80's",
          mapping_id: null,
        },
        {
          id: 103,
          name: "Classic Lounge",
          mapping_id: null,
        },
      ],
    },
    {
      id: 19,
      name: "Pop",
      parent: null,
      children: [
        {
          id: 104,
          name: "Brit Pop",
          mapping_id: null,
        },
        {
          id: 105,
          name: "Electropop",
          mapping_id: null,
        },
        {
          id: 106,
          name: "Pop (Singer/Songwriter)",
          mapping_id: null,
        },
      ],
    },
    {
      id: 20,
      name: "R&B/Soul",
      parent: null,
      children: [
        {
          id: 217,
          name: "Christian & Gospel",
          mapping_id: null,
        },
        {
          id: 107,
          name: "Classic Soul",
          mapping_id: null,
        },
        {
          id: 108,
          name: "Funk",
          mapping_id: null,
        },
        {
          id: 109,
          name: "New Soul",
          mapping_id: null,
        },
        {
          id: 110,
          name: "R&B",
          mapping_id: null,
        },
        {
          id: 219,
          name: "Rap/Hip-Hop",
          mapping_id: null,
        },
        {
          id: 111,
          name: "Soul",
          mapping_id: null,
        },
      ],
    },
    {
      id: 21,
      name: "Rap/Hip-Hop",
      parent: null,
      children: [
        {
          id: 250,
          name: "African Rap",
          mapping_id: null,
        },
        {
          id: 211,
          name: "Christian & Gospel",
          mapping_id: null,
        },
        {
          id: 112,
          name: "Crunk",
          mapping_id: null,
        },
        {
          id: 113,
          name: "Dirty South",
          mapping_id: null,
        },
        {
          id: 114,
          name: "East Coast Rap/Hip-Hop",
          mapping_id: null,
        },
        {
          id: 115,
          name: "Gangsta Rap",
          mapping_id: null,
        },
        {
          id: 116,
          name: "Hip-Hop",
          mapping_id: null,
        },
        {
          id: 117,
          name: "International Rap/Hip-Hop",
          mapping_id: null,
        },
        {
          id: 118,
          name: "Old School Rap/Hip-Hop",
          mapping_id: null,
        },
        {
          id: 119,
          name: "Pop Rap/Hip-Hop",
          mapping_id: null,
        },
        {
          id: 218,
          name: "R&B/Soul",
          mapping_id: null,
        },
        {
          id: 120,
          name: "Rap",
          mapping_id: null,
        },
        {
          id: 121,
          name: "Southern Rap/Hip-Hop",
          mapping_id: null,
        },
        {
          id: 122,
          name: "Turntablism",
          mapping_id: null,
        },
        {
          id: 123,
          name: "West Coast Rap/Hip-Hop",
          mapping_id: null,
        },
      ],
    },
    {
      id: 22,
      name: "Reggae",
      parent: null,
      children: [
        {
          id: 124,
          name: "Dancehall",
          mapping_id: null,
        },
        {
          id: 125,
          name: "Dub",
          mapping_id: null,
        },
        {
          id: 216,
          name: "Modern Dancehall",
          mapping_id: null,
        },
        {
          id: 126,
          name: "Ragga",
          mapping_id: null,
        },
        {
          id: 127,
          name: "Reggaeton",
          mapping_id: null,
        },
        {
          id: 128,
          name: "Roots",
          mapping_id: null,
        },
        {
          id: 129,
          name: "Ska",
          mapping_id: null,
        },
      ],
    },
    {
      id: 23,
      name: "Rock",
      parent: null,
      children: [
        {
          id: 130,
          name: "Alternative",
          mapping_id: null,
        },
        {
          id: 131,
          name: "Black Metal",
          mapping_id: null,
        },
        {
          id: 132,
          name: "Classic Rock",
          mapping_id: null,
        },
        {
          id: 133,
          name: "Death Metal",
          mapping_id: null,
        },
        {
          id: 134,
          name: "EMO",
          mapping_id: null,
        },
        {
          id: 135,
          name: "Glam Rock",
          mapping_id: null,
        },
        {
          id: 136,
          name: "Goth",
          mapping_id: null,
        },
        {
          id: 137,
          name: "Grunge",
          mapping_id: null,
        },
        {
          id: 138,
          name: "Grungecore",
          mapping_id: null,
        },
        {
          id: 139,
          name: "Hard Rock",
          mapping_id: null,
        },
        {
          id: 140,
          name: "Indie Rock",
          mapping_id: null,
        },
        {
          id: 141,
          name: "Metal",
          mapping_id: null,
        },
        {
          id: 142,
          name: "New Wave",
          mapping_id: null,
        },
        {
          id: 143,
          name: "Prog Rock",
          mapping_id: null,
        },
        {
          id: 144,
          name: "Punk",
          mapping_id: null,
        },
        {
          id: 145,
          name: "Rock (Singer/Songwriter)",
          mapping_id: null,
        },
        {
          id: 146,
          name: "Rockabilly",
          mapping_id: null,
        },
        {
          id: 147,
          name: "Surf",
          mapping_id: null,
        },
        {
          id: 148,
          name: "Thrash/Speedmetal",
          mapping_id: null,
        },
      ],
    },
    {
      id: 24,
      name: "Soundtrack",
      parent: null,
      children: [
        {
          id: 149,
          name: "Film Scores",
          mapping_id: null,
        },
        {
          id: 150,
          name: "Musicals",
          mapping_id: null,
        },
        {
          id: 151,
          name: "TV",
          mapping_id: null,
        },
      ],
    },
    {
      id: 25,
      name: "Spoken Word",
      parent: null,
      children: [
        {
          id: 152,
          name: "Lecture",
          mapping_id: null,
        },
        {
          id: 153,
          name: "Poetry",
          mapping_id: null,
        },
        {
          id: 154,
          name: "Poetry Slam",
          mapping_id: null,
        },
        {
          id: 155,
          name: "Speeches",
          mapping_id: null,
        },
      ],
    },
    {
      id: 26,
      name: "World",
      parent: null,
      children: [
        {
          id: 156,
          name: "African",
          mapping_id: null,
        },
        {
          id: 157,
          name: "Afro Beat",
          mapping_id: null,
        },
        {
          id: 158,
          name: "Afro Pop",
          mapping_id: null,
        },
        {
          id: 159,
          name: "Asian",
          mapping_id: null,
        },
        {
          id: 160,
          name: "Brazillian",
          mapping_id: null,
        },
        {
          id: 161,
          name: "Caribbean",
          mapping_id: null,
        },
        {
          id: 162,
          name: "Celtic",
          mapping_id: null,
        },
        {
          id: 163,
          name: "European/Mediterranean",
          mapping_id: null,
        },
        {
          id: 164,
          name: "India",
          mapping_id: null,
        },
        {
          id: 165,
          name: "Middle East",
          mapping_id: null,
        },
        {
          id: 166,
          name: "Native American",
          mapping_id: null,
        },
        {
          id: 167,
          name: "New Age",
          mapping_id: null,
        },
      ],
    },
    {
      id: 51,
      name: "Dance",
      parent: null,
      children: [
        {
          id: 179,
          name: "2 Step",
          mapping_id: null,
        },
        {
          id: 180,
          name: "Acid House",
          mapping_id: null,
        },
        {
          id: 181,
          name: "Ambient",
          mapping_id: null,
        },
        {
          id: 182,
          name: "Beats & Breaks",
          mapping_id: null,
        },
        {
          id: 183,
          name: "Breaks",
          mapping_id: null,
        },
        {
          id: 184,
          name: "Broken Beat",
          mapping_id: null,
        },
        {
          id: 185,
          name: "Deep House",
          mapping_id: null,
        },
        {
          id: 186,
          name: "Disco",
          mapping_id: null,
        },
        {
          id: 187,
          name: "Downtempo",
          mapping_id: null,
        },
        {
          id: 188,
          name: "Drum & Bass",
          mapping_id: null,
        },
        {
          id: 189,
          name: "Electro House",
          mapping_id: null,
        },
        {
          id: 190,
          name: "Electronic Lounge",
          mapping_id: null,
        },
        {
          id: 191,
          name: "Electronica",
          mapping_id: null,
        },
        {
          id: 192,
          name: "Experimental",
          mapping_id: null,
        },
        {
          id: 193,
          name: "Funky Breaks",
          mapping_id: null,
        },
        {
          id: 194,
          name: "Funky House",
          mapping_id: null,
        },
        {
          id: 195,
          name: "Garage",
          mapping_id: null,
        },
        {
          id: 214,
          name: "Garage / Bassline / Grime",
          mapping_id: null,
        },
        {
          id: 196,
          name: "Glitch",
          mapping_id: null,
        },
        {
          id: 197,
          name: "Hard House",
          mapping_id: null,
        },
        {
          id: 198,
          name: "House",
          mapping_id: null,
        },
        {
          id: 199,
          name: "Leftfield/IDM",
          mapping_id: null,
        },
        {
          id: 200,
          name: "Miami Bass",
          mapping_id: null,
        },
        {
          id: 201,
          name: "Minimal Techno",
          mapping_id: null,
        },
        {
          id: 202,
          name: "Nu Skool Breaks",
          mapping_id: null,
        },
        {
          id: 203,
          name: "Progressive House",
          mapping_id: null,
        },
        {
          id: 204,
          name: "Progressive Trance",
          mapping_id: null,
        },
        {
          id: 205,
          name: "Psy Trance",
          mapping_id: null,
        },
        {
          id: 206,
          name: "Tech House",
          mapping_id: null,
        },
        {
          id: 207,
          name: "Techno",
          mapping_id: null,
        },
        {
          id: 208,
          name: "Trance",
          mapping_id: null,
        },
        {
          id: 213,
          name: "Trap / Future Bass",
          mapping_id: null,
        },
        {
          id: 209,
          name: "Tribal House",
          mapping_id: null,
        },
        {
          id: 210,
          name: "Trip Hop",
          mapping_id: null,
        },
      ],
    },
    {
      id: 170,
      name: "Country",
      parent: null,
      children: [
        {
          id: 39,
          name: "Alt. Country",
          mapping_id: null,
        },
        {
          id: 40,
          name: "Americana",
          mapping_id: null,
        },
        {
          id: 41,
          name: "Bluegrass",
          mapping_id: null,
        },
        {
          id: 42,
          name: "Country (Contemporary)",
          mapping_id: null,
        },
        {
          id: 43,
          name: "Country (Traditional)",
          mapping_id: null,
        },
        {
          id: 44,
          name: "Country Rock",
          mapping_id: null,
        },
      ],
    },
    {
      id: 171,
      name: "Dubstep",
      parent: null,
      children: [],
    },
    {
      id: 172,
      name: "Metal",
      parent: null,
      children: [],
    },
    {
      id: 173,
      name: "Alternative",
      parent: null,
      children: [],
    },
    {
      id: 174,
      name: "Karaoke",
      parent: null,
      children: [],
    },
    {
      id: 220,
      name: "K-Pop",
      parent: null,
      children: [
        {
          id: 221,
          name: "Pop",
          mapping_id: null,
        },
      ],
    },
    {
      id: 222,
      name: "African",
      parent: null,
      children: [
        {
          id: 246,
          name: "African Dancehall",
          mapping_id: null,
        },
        {
          id: 247,
          name: "African Reggae",
          mapping_id: null,
        },
        {
          id: 223,
          name: "Afrikaans",
          mapping_id: null,
        },
        {
          id: 224,
          name: "Afro House",
          mapping_id: null,
        },
        {
          id: 225,
          name: "Afro Soul",
          mapping_id: null,
        },
        {
          id: 226,
          name: "Afro-Beat",
          mapping_id: null,
        },
        {
          id: 248,
          name: "Afro-folk",
          mapping_id: null,
        },
        {
          id: 249,
          name: "Afro-fusion",
          mapping_id: null,
        },
        {
          id: 227,
          name: "Afro-Pop",
          mapping_id: null,
        },
        {
          id: 228,
          name: "Afrobeats",
          mapping_id: null,
        },
        {
          id: 244,
          name: "Alte",
          mapping_id: null,
        },
        {
          id: 245,
          name: "Amapiano",
          mapping_id: null,
        },
        {
          id: 229,
          name: "Benga",
          mapping_id: null,
        },
        {
          id: 230,
          name: "Bongo-Flava",
          mapping_id: null,
        },
        {
          id: 231,
          name: "Coupe-Decale",
          mapping_id: null,
        },
        {
          id: 232,
          name: "Gqom",
          mapping_id: null,
        },
        {
          id: 233,
          name: "Highlife",
          mapping_id: null,
        },
        {
          id: 234,
          name: "Kizomba",
          mapping_id: null,
        },
        {
          id: 235,
          name: "Kuduro",
          mapping_id: null,
        },
        {
          id: 236,
          name: "Kwaito",
          mapping_id: null,
        },
        {
          id: 237,
          name: "Maskandi",
          mapping_id: null,
        },
        {
          id: 238,
          name: "Mbalax",
          mapping_id: null,
        },
        {
          id: 239,
          name: "Ndombolo",
          mapping_id: null,
        },
        {
          id: 240,
          name: "Shangaan Electro",
          mapping_id: null,
        },
        {
          id: 241,
          name: "Soukous",
          mapping_id: null,
        },
        {
          id: 242,
          name: "Taarab",
          mapping_id: null,
        },
        {
          id: 243,
          name: "Zouglou",
          mapping_id: null,
        },
      ],
    },
  ],
  languages: [
    {
      id: 1,
      name: "Abkhaz",
      long_code: "abk",
      code: "ab",
    },
    {
      id: 2,
      name: "Afar",
      long_code: "aar",
      code: "aa",
    },
    {
      id: 3,
      name: "Afrikaans",
      long_code: "afr",
      code: "af",
    },
    {
      id: 4,
      name: "Akan",
      long_code: "aka",
      code: "ak",
    },
    {
      id: 5,
      name: "Albanian",
      long_code: "alb",
      code: "sq",
    },
    {
      id: 6,
      name: "Amharic",
      long_code: "amh",
      code: "am",
    },
    {
      id: 7,
      name: "Arabic",
      long_code: "ara",
      code: "ar",
    },
    {
      id: 8,
      name: "Aragonese",
      long_code: "arg",
      code: "an",
    },
    {
      id: 9,
      name: "Armenian",
      long_code: "arm",
      code: "hy",
    },
    {
      id: 10,
      name: "Assamese",
      long_code: "asm",
      code: "as",
    },
    {
      id: 11,
      name: "Avaric",
      long_code: "ava",
      code: "av",
    },
    {
      id: 12,
      name: "Avestan",
      long_code: "ave",
      code: "ae",
    },
    {
      id: 13,
      name: "Aymara",
      long_code: "aym",
      code: "ay",
    },
    {
      id: 14,
      name: "Azerbaijani",
      long_code: "aze",
      code: "az",
    },
    {
      id: 15,
      name: "Bambara",
      long_code: "bam",
      code: "bm",
    },
    {
      id: 16,
      name: "Bashkir",
      long_code: "bak",
      code: "ba",
    },
    {
      id: 17,
      name: "Basque",
      long_code: "baq",
      code: "eu",
    },
    {
      id: 18,
      name: "Belarusian",
      long_code: "bel",
      code: "be",
    },
    {
      id: 19,
      name: "Bengali; Bangla",
      long_code: "ben",
      code: "bn",
    },
    {
      id: 20,
      name: "Bihari",
      long_code: "bih",
      code: "bh",
    },
    {
      id: 21,
      name: "Bislama",
      long_code: "bis",
      code: "bi",
    },
    {
      id: 22,
      name: "Bosnian",
      long_code: "bos",
      code: "bs",
    },
    {
      id: 23,
      name: "Breton",
      long_code: "bre",
      code: "br",
    },
    {
      id: 24,
      name: "Bulgarian",
      long_code: "bul",
      code: "bg",
    },
    {
      id: 25,
      name: "Burmese",
      long_code: "bur",
      code: "my",
    },
    {
      id: 26,
      name: "Catalan; Valencian",
      long_code: "cat",
      code: "ca",
    },
    {
      id: 27,
      name: "Chamorro",
      long_code: "cha",
      code: "ch",
    },
    {
      id: 28,
      name: "Chechen",
      long_code: "che",
      code: "ce",
    },
    {
      id: 29,
      name: "Chichewa; Chewa; Nyanja",
      long_code: "nya",
      code: "ny",
    },
    {
      id: 30,
      name: "Chinese (Generic)",
      long_code: "zho",
      code: "zh",
    },
    {
      id: 31,
      name: "Chuvash",
      long_code: "chv",
      code: "cv",
    },
    {
      id: 32,
      name: "Cornish",
      long_code: "cor",
      code: "kw",
    },
    {
      id: 33,
      name: "Corsican",
      long_code: "cos",
      code: "co",
    },
    {
      id: 34,
      name: "Cree",
      long_code: "cre",
      code: "cr",
    },
    {
      id: 35,
      name: "Croatian",
      long_code: "hrv",
      code: "hr",
    },
    {
      id: 36,
      name: "Czech",
      long_code: "ces",
      code: "cs",
    },
    {
      id: 37,
      name: "Danish",
      long_code: "dan",
      code: "da",
    },
    {
      id: 38,
      name: "Divehi; Dhivehi; Maldivian;",
      long_code: "div",
      code: "dv",
    },
    {
      id: 39,
      name: "Dutch",
      long_code: "nld",
      code: "nl",
    },
    {
      id: 40,
      name: "Dzongkha",
      long_code: "dzo",
      code: "dz",
    },
    {
      id: 41,
      name: "English",
      long_code: "eng",
      code: "en",
    },
    {
      id: 42,
      name: "Esperanto",
      long_code: "epo",
      code: "eo",
    },
    {
      id: 43,
      name: "Estonian",
      long_code: "est",
      code: "et",
    },
    {
      id: 44,
      name: "Ewe",
      long_code: "ewe",
      code: "ee",
    },
    {
      id: 45,
      name: "Faroese",
      long_code: "fao",
      code: "fo",
    },
    {
      id: 46,
      name: "Fijian",
      long_code: "fij",
      code: "fj",
    },
    {
      id: 47,
      name: "Finnish",
      long_code: "fin",
      code: "fi",
    },
    {
      id: 48,
      name: "French",
      long_code: "fra",
      code: "fr",
    },
    {
      id: 49,
      name: "Fula; Fulah; Pulaar; Pular",
      long_code: "ful",
      code: "ff",
    },
    {
      id: 50,
      name: "Galician",
      long_code: "glg",
      code: "gl",
    },
    {
      id: 51,
      name: "Georgian",
      long_code: "geo",
      code: "ka",
    },
    {
      id: 52,
      name: "German",
      long_code: "ger",
      code: "de",
    },
    {
      id: 53,
      name: "Greek, Modern",
      long_code: "gre",
      code: "el",
    },
    {
      id: 54,
      name: "GuaranÃ­",
      long_code: "grn",
      code: "gn",
    },
    {
      id: 55,
      name: "Gujarati",
      long_code: "guj",
      code: "gu",
    },
    {
      id: 56,
      name: "Haitian; Haitian Creole",
      long_code: "hat",
      code: "ht",
    },
    {
      id: 57,
      name: "Hausa",
      long_code: "hau",
      code: "ha",
    },
    {
      id: 58,
      name: "Hebrew (modern)",
      long_code: "heb",
      code: "he",
    },
    {
      id: 59,
      name: "Herero",
      long_code: "her",
      code: "hz",
    },
    {
      id: 60,
      name: "Hindi",
      long_code: "hin",
      code: "hi",
    },
    {
      id: 61,
      name: "Hiri Motu",
      long_code: "hmo",
      code: "ho",
    },
    {
      id: 62,
      name: "Hungarian",
      long_code: "hun",
      code: "hu",
    },
    {
      id: 63,
      name: "Interlingua",
      long_code: "ina",
      code: "ia",
    },
    {
      id: 64,
      name: "Indonesian",
      long_code: "ind",
      code: "id",
    },
    {
      id: 65,
      name: "Interlingue",
      long_code: "ile",
      code: "ie",
    },
    {
      id: 66,
      name: "Irish",
      long_code: "gle",
      code: "ga",
    },
    {
      id: 67,
      name: "Igbo",
      long_code: "ibo",
      code: "ig",
    },
    {
      id: 68,
      name: "Inupiaq",
      long_code: "ipk",
      code: "ik",
    },
    {
      id: 69,
      name: "Ido",
      long_code: "ido",
      code: "io",
    },
    {
      id: 70,
      name: "Icelandic",
      long_code: "ice",
      code: "is",
    },
    {
      id: 71,
      name: "Italian",
      long_code: "ita",
      code: "it",
    },
    {
      id: 72,
      name: "Inuktitut",
      long_code: "iku",
      code: "iu",
    },
    {
      id: 73,
      name: "Japanese",
      long_code: "jpn",
      code: "ja",
    },
    {
      id: 74,
      name: "Javanese",
      long_code: "jav",
      code: "jv",
    },
    {
      id: 75,
      name: "Kalaallisut, Greenlandic",
      long_code: "kal",
      code: "kl",
    },
    {
      id: 76,
      name: "Kannada",
      long_code: "kan",
      code: "kn",
    },
    {
      id: 77,
      name: "Kanuri",
      long_code: "kau",
      code: "kr",
    },
    {
      id: 78,
      name: "Kashmiri",
      long_code: "kas",
      code: "ks",
    },
    {
      id: 79,
      name: "Kazakh",
      long_code: "kaz",
      code: "kk",
    },
    {
      id: 80,
      name: "Khmer",
      long_code: "khm",
      code: "km",
    },
    {
      id: 81,
      name: "Kikuyu, Gikuyu",
      long_code: "kik",
      code: "ki",
    },
    {
      id: 82,
      name: "Kinyarwanda",
      long_code: "kin",
      code: "rw",
    },
    {
      id: 83,
      name: "Kyrgyz",
      long_code: "kir",
      code: "ky",
    },
    {
      id: 84,
      name: "Komi",
      long_code: "kom",
      code: "kv",
    },
    {
      id: 85,
      name: "Kongo",
      long_code: "kon",
      code: "kg",
    },
    {
      id: 86,
      name: "Korean",
      long_code: "kor",
      code: "ko",
    },
    {
      id: 87,
      name: "Kurdish",
      long_code: "kur",
      code: "ku",
    },
    {
      id: 88,
      name: "Kwanyama, Kuanyama",
      long_code: "kua",
      code: "kj",
    },
    {
      id: 89,
      name: "Latin",
      long_code: "lat",
      code: "la",
    },
    {
      id: 90,
      name: "Luxembourgish, Letzeburgesch",
      long_code: "ltz",
      code: "lb",
    },
    {
      id: 91,
      name: "Ganda",
      long_code: "lug",
      code: "lg",
    },
    {
      id: 92,
      name: "Limburgish, Limburgan, Limburger",
      long_code: "lim",
      code: "li",
    },
    {
      id: 93,
      name: "Lingala",
      long_code: "lin",
      code: "ln",
    },
    {
      id: 94,
      name: "Lao",
      long_code: "lao",
      code: "lo",
    },
    {
      id: 95,
      name: "Lithuanian",
      long_code: "lit",
      code: "lt",
    },
    {
      id: 96,
      name: "Luba-Katanga",
      long_code: "lub",
      code: "lu",
    },
    {
      id: 97,
      name: "Latvian",
      long_code: "lav",
      code: "lv",
    },
    {
      id: 98,
      name: "Manx",
      long_code: "glv",
      code: "gv",
    },
    {
      id: 99,
      name: "Macedonian",
      long_code: "mkd",
      code: "mk",
    },
    {
      id: 100,
      name: "Malagasy",
      long_code: "mlg",
      code: "mg",
    },
    {
      id: 101,
      name: "Malay",
      long_code: "msa",
      code: "ms",
    },
    {
      id: 102,
      name: "Malayalam",
      long_code: "mal",
      code: "ml",
    },
    {
      id: 103,
      name: "Maltese",
      long_code: "mlt",
      code: "mt",
    },
    {
      id: 104,
      name: "Maori",
      long_code: "mri",
      code: "mi",
    },
    {
      id: 105,
      name: "Marathi",
      long_code: "mar",
      code: "mr",
    },
    {
      id: 106,
      name: "Marshallese",
      long_code: "mah",
      code: "mh",
    },
    {
      id: 107,
      name: "Mongolian",
      long_code: "mon",
      code: "mn",
    },
    {
      id: 108,
      name: "Nauru",
      long_code: "nau",
      code: "na",
    },
    {
      id: 109,
      name: "Navajo, Navaho",
      long_code: "nav",
      code: "nv",
    },
    {
      id: 110,
      name: "Norwegian BokmÃ¥l",
      long_code: "nob",
      code: "nb",
    },
    {
      id: 111,
      name: "North Ndebele",
      long_code: "nde",
      code: "nd",
    },
    {
      id: 112,
      name: "Nepali",
      long_code: "nep",
      code: "ne",
    },
    {
      id: 113,
      name: "Ndonga",
      long_code: "ndo",
      code: "ng",
    },
    {
      id: 114,
      name: "Norwegian Nynorsk",
      long_code: "nno",
      code: "nn",
    },
    {
      id: 115,
      name: "Norwegian",
      long_code: "nor",
      code: "no",
    },
    {
      id: 116,
      name: "Nuosu",
      long_code: "iii",
      code: "ii",
    },
    {
      id: 117,
      name: "South Ndebele",
      long_code: "nbl",
      code: "nr",
    },
    {
      id: 118,
      name: "Occitan",
      long_code: "oci",
      code: "oc",
    },
    {
      id: 119,
      name: "Ojibwe, Ojibwa",
      long_code: "oji",
      code: "oj",
    },
    {
      id: 120,
      name: "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
      long_code: "chu",
      code: "cu",
    },
    {
      id: 121,
      name: "Oromo",
      long_code: "orm",
      code: "om",
    },
    {
      id: 122,
      name: "Oriya",
      long_code: "ori",
      code: "or",
    },
    {
      id: 123,
      name: "Ossetian, Ossetic",
      long_code: "oss",
      code: "os",
    },
    {
      id: 124,
      name: "Panjabi, Punjabi",
      long_code: "pan",
      code: "pa",
    },
    {
      id: 125,
      name: "Pali",
      long_code: "pli",
      code: "pi",
    },
    {
      id: 126,
      name: "Persian (Farsi)",
      long_code: "fas",
      code: "fa",
    },
    {
      id: 127,
      name: "Polish",
      long_code: "pol",
      code: "pl",
    },
    {
      id: 128,
      name: "Pashto, Pushto",
      long_code: "pus",
      code: "ps",
    },
    {
      id: 129,
      name: "Portuguese",
      long_code: "por",
      code: "pt",
    },
    {
      id: 130,
      name: "Quechua",
      long_code: "que",
      code: "qu",
    },
    {
      id: 131,
      name: "Romansh",
      long_code: "roh",
      code: "rm",
    },
    {
      id: 132,
      name: "Kirundi",
      long_code: "run",
      code: "rn",
    },
    {
      id: 133,
      name: "Romanian",
      long_code: "ron",
      code: "ro",
    },
    {
      id: 134,
      name: "Russian",
      long_code: "rus",
      code: "ru",
    },
    {
      id: 135,
      name: "Sanskrit",
      long_code: "san",
      code: "sa",
    },
    {
      id: 136,
      name: "Sardinian",
      long_code: "srd",
      code: "sc",
    },
    {
      id: 137,
      name: "Sindhi",
      long_code: "snd",
      code: "sd",
    },
    {
      id: 138,
      name: "Northern Sami",
      long_code: "sme",
      code: "se",
    },
    {
      id: 139,
      name: "Samoan",
      long_code: "smo",
      code: "sm",
    },
    {
      id: 140,
      name: "Sango",
      long_code: "sag",
      code: "sg",
    },
    {
      id: 141,
      name: "Serbian",
      long_code: "srp",
      code: "sr",
    },
    {
      id: 142,
      name: "Scottish Gaelic; Gaelic",
      long_code: "gla",
      code: "gd",
    },
    {
      id: 143,
      name: "Shona",
      long_code: "sna",
      code: "sn",
    },
    {
      id: 144,
      name: "Sinhala, Sinhalese",
      long_code: "sin",
      code: "si",
    },
    {
      id: 145,
      name: "Slovak",
      long_code: "slk",
      code: "sk",
    },
    {
      id: 146,
      name: "Slovene",
      long_code: "slv",
      code: "sl",
    },
    {
      id: 147,
      name: "Somali",
      long_code: "som",
      code: "so",
    },
    {
      id: 148,
      name: "Southern Sotho",
      long_code: "sot",
      code: "st",
    },
    {
      id: 149,
      name: "South Azerbaijani",
      long_code: "aze",
      code: "az",
    },
    {
      id: 150,
      name: "Spanish",
      long_code: "spa",
      code: "es",
    },
    {
      id: 151,
      name: "Sundanese",
      long_code: "sun",
      code: "su",
    },
    {
      id: 152,
      name: "Swahili",
      long_code: "swa",
      code: "sw",
    },
    {
      id: 153,
      name: "Swati",
      long_code: "ssw",
      code: "ss",
    },
    {
      id: 154,
      name: "Swedish",
      long_code: "swe",
      code: "sv",
    },
    {
      id: 155,
      name: "Tamil",
      long_code: "tam",
      code: "ta",
    },
    {
      id: 156,
      name: "Telugu",
      long_code: "tel",
      code: "te",
    },
    {
      id: 157,
      name: "Tajik",
      long_code: "tgk",
      code: "tg",
    },
    {
      id: 158,
      name: "Thai",
      long_code: "tha",
      code: "th",
    },
    {
      id: 159,
      name: "Tigrinya",
      long_code: "tir",
      code: "ti",
    },
    {
      id: 160,
      name: "Tibetan Standard, Tibetan, Central",
      long_code: "bod",
      code: "bo",
    },
    {
      id: 161,
      name: "Turkmen",
      long_code: "tuk",
      code: "tk",
    },
    {
      id: 162,
      name: "Tagalog",
      long_code: "tgl",
      code: "tl",
    },
    {
      id: 163,
      name: "Tswana",
      long_code: "tsn",
      code: "tn",
    },
    {
      id: 164,
      name: "Tonga (Tonga Islands)",
      long_code: "ton",
      code: "to",
    },
    {
      id: 165,
      name: "Turkish",
      long_code: "tur",
      code: "tr",
    },
    {
      id: 166,
      name: "Tsonga",
      long_code: "tso",
      code: "ts",
    },
    {
      id: 167,
      name: "Tatar",
      long_code: "tat",
      code: "tt",
    },
    {
      id: 168,
      name: "Twi",
      long_code: "twi",
      code: "tw",
    },
    {
      id: 169,
      name: "Tahitian",
      long_code: "tah",
      code: "ty",
    },
    {
      id: 170,
      name: "Uyghur, Uighur",
      long_code: "uig",
      code: "ug",
    },
    {
      id: 171,
      name: "Ukrainian",
      long_code: "ukr",
      code: "uk",
    },
    {
      id: 172,
      name: "Urdu",
      long_code: "urd",
      code: "ur",
    },
    {
      id: 173,
      name: "Uzbek",
      long_code: "uzb",
      code: "uz",
    },
    {
      id: 174,
      name: "Venda",
      long_code: "ven",
      code: "ve",
    },
    {
      id: 175,
      name: "Vietnamese",
      long_code: "vie",
      code: "vi",
    },
    {
      id: 176,
      name: "VolapÃ¼k",
      long_code: "vol",
      code: "vo",
    },
    {
      id: 177,
      name: "Walloon",
      long_code: "wln",
      code: "wa",
    },
    {
      id: 178,
      name: "Welsh",
      long_code: "cym",
      code: "cy",
    },
    {
      id: 179,
      name: "Wolof",
      long_code: "wol",
      code: "wo",
    },
    {
      id: 180,
      name: "Western Frisian",
      long_code: "fry",
      code: "fy",
    },
    {
      id: 181,
      name: "Xhosa",
      long_code: "xho",
      code: "xh",
    },
    {
      id: 182,
      name: "Yiddish",
      long_code: "yid",
      code: "yi",
    },
    {
      id: 183,
      name: "Yoruba",
      long_code: "yor",
      code: "yo",
    },
    {
      id: 184,
      name: "Zhuang, Chuang",
      long_code: "zha",
      code: "za",
    },
    {
      id: 185,
      name: "Zulu",
      long_code: "zul",
      code: "zu",
    },
    {
      id: 186,
      name: "ZXX (No Language)",
      long_code: "zxx",
      code: "zxx",
    },
    {
      id: 187,
      name: "Chinese (Mandarin)",
      long_code: "cmn",
      code: "cmn",
    },
    {
      id: 188,
      name: "Chinese (Cantonese)",
      long_code: "yue",
      code: "yue",
    },
    {
      id: 189,
      name: "Chinese (Gan)",
      long_code: "gan",
      code: "gan",
    },
  ],
  countries: [
    {
      id: 3,
      name: "Afghanistan",
      code: "AF",
      code_a3: null,
      currency_code: "AFN",
      region_name: "Asia",
      utc_offset: "4.50",
      timezone: "Asia/Kabul",
    },
    {
      id: 15,
      name: "Aland Islands",
      code: "AX",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Mariehamn",
    },
    {
      id: 6,
      name: "Albania",
      code: "AL",
      code_a3: null,
      currency_code: "ALL",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Tirane",
    },
    {
      id: 62,
      name: "Algeria",
      code: "DZ",
      code_a3: null,
      currency_code: "DZD",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Algiers",
    },
    {
      id: 11,
      name: "American Samoa",
      code: "AS",
      code_a3: null,
      currency_code: "USD",
      region_name: "Oceania",
      utc_offset: "-11.00",
      timezone: "Pacific/Samoa",
    },
    {
      id: 1,
      name: "Andorra",
      code: "AD",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Andorra",
    },
    {
      id: 8,
      name: "Angola",
      code: "AO",
      code_a3: null,
      currency_code: "AOA",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Luanda",
    },
    {
      id: 5,
      name: "Anguilla",
      code: "AI",
      code_a3: null,
      currency_code: "XCD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Anguilla",
    },
    {
      id: 9,
      name: "Antarctica",
      code: "AQ",
      code_a3: null,
      currency_code: "USD",
      region_name: "Other",
      utc_offset: "1.00",
      timezone: "Arctic/Longyearbyen",
    },
    {
      id: 4,
      name: "Antigua and Barbuda",
      code: "AG",
      code_a3: null,
      currency_code: "XCD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Antigua",
    },
    {
      id: 10,
      name: "Argentina",
      code: "AR",
      code_a3: null,
      currency_code: "ARS",
      region_name: "South America",
      utc_offset: "-3.00",
      timezone: "America/Argentina/Buenos_Aires",
    },
    {
      id: 7,
      name: "Armenia",
      code: "AM",
      code_a3: null,
      currency_code: "AMD",
      region_name: "Asia",
      utc_offset: "4.00",
      timezone: "Asia/Yerevan",
    },
    {
      id: 14,
      name: "Aruba",
      code: "AW",
      code_a3: null,
      currency_code: "AWG",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Aruba",
    },
    {
      id: 13,
      name: "Australia",
      code: "AU",
      code_a3: null,
      currency_code: "AUD",
      region_name: "Oceania",
      utc_offset: "11.00",
      timezone: "Australia/Sydney",
    },
    {
      id: 12,
      name: "Austria",
      code: "AT",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Vienna",
    },
    {
      id: 16,
      name: "Azerbaijan",
      code: "AZ",
      code_a3: null,
      currency_code: "AZN",
      region_name: "Asia",
      utc_offset: "4.00",
      timezone: "Asia/Baku",
    },
    {
      id: 32,
      name: "Bahamas",
      code: "BS",
      code_a3: null,
      currency_code: "BSD",
      region_name: "The Caribbean",
      utc_offset: "-5.00",
      timezone: "America/Nassau",
    },
    {
      id: 23,
      name: "Bahrain",
      code: "BH",
      code_a3: null,
      currency_code: "BHD",
      region_name: "Middle East",
      utc_offset: "3.00",
      timezone: "Asia/Bahrain",
    },
    {
      id: 19,
      name: "Bangladesh",
      code: "BD",
      code_a3: null,
      currency_code: "BDT",
      region_name: "Asia",
      utc_offset: "6.00",
      timezone: "Asia/Dhaka",
    },
    {
      id: 18,
      name: "Barbados",
      code: "BB",
      code_a3: null,
      currency_code: "BBD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Barbados",
    },
    {
      id: 36,
      name: "Belarus",
      code: "BY",
      code_a3: null,
      currency_code: "BYR",
      region_name: "Europe",
      utc_offset: "3.00",
      timezone: "Europe/Minsk",
    },
    {
      id: 20,
      name: "Belgium",
      code: "BE",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Brussels",
    },
    {
      id: 37,
      name: "Belize",
      code: "BZ",
      code_a3: null,
      currency_code: "BZD",
      region_name: "Central America",
      utc_offset: "-6.00",
      timezone: "America/Belize",
    },
    {
      id: 25,
      name: "Benin",
      code: "BJ",
      code_a3: null,
      currency_code: "XOF",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Porto-Novo",
    },
    {
      id: 27,
      name: "Bermuda",
      code: "BM",
      code_a3: null,
      currency_code: "BMD",
      region_name: "North America",
      utc_offset: "-4.00",
      timezone: "Atlantic/Bermuda",
    },
    {
      id: 33,
      name: "Bhutan",
      code: "BT",
      code_a3: null,
      currency_code: "BTN",
      region_name: "Asia",
      utc_offset: "6.00",
      timezone: "Asia/Thimphu",
    },
    {
      id: 29,
      name: "Bolivia, Plurinational State of",
      code: "BO",
      code_a3: null,
      currency_code: "BOB",
      region_name: "South America",
      utc_offset: "-4.00",
      timezone: "America/La_Paz",
    },
    {
      id: 30,
      name: "Bonaire, Sint Eustatius and Saba",
      code: "BQ",
      code_a3: null,
      currency_code: "USD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/St_Barthelemy",
    },
    {
      id: 17,
      name: "Bosnia and Herzegovina",
      code: "BA",
      code_a3: null,
      currency_code: "BAM",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Sarajevo",
    },
    {
      id: 35,
      name: "Botswana",
      code: "BW",
      code_a3: null,
      currency_code: "BWP",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Gaborone",
    },
    {
      id: 34,
      name: "Bouvet Island",
      code: "BV",
      code_a3: null,
      currency_code: "NOK",
      region_name: "Other",
      utc_offset: "1.00",
      timezone: "Europe/Paris",
    },
    {
      id: 31,
      name: "Brazil",
      code: "BR",
      code_a3: null,
      currency_code: "BRL",
      region_name: "South America",
      utc_offset: "-2.00",
      timezone: "America/Sao_Paulo",
    },
    {
      id: 106,
      name: "British Indian Ocean Territory",
      code: "IO",
      code_a3: null,
      currency_code: "GBP",
      region_name: "Other",
      utc_offset: "6.00",
      timezone: "Asia/Dhaka",
    },
    {
      id: 28,
      name: "Brunei Darussalam",
      code: "BN",
      code_a3: null,
      currency_code: "BND",
      region_name: "Asia",
      utc_offset: "8.00",
      timezone: "Asia/Brunei",
    },
    {
      id: 22,
      name: "Bulgaria",
      code: "BG",
      code_a3: null,
      currency_code: "BGN",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Sofia",
    },
    {
      id: 21,
      name: "Burkina Faso",
      code: "BF",
      code_a3: null,
      currency_code: "XOF",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Ouagadougou",
    },
    {
      id: 24,
      name: "Burundi",
      code: "BI",
      code_a3: null,
      currency_code: "BIF",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Bujumbura",
    },
    {
      id: 117,
      name: "Cambodia",
      code: "KH",
      code_a3: null,
      currency_code: "KHR",
      region_name: "Asia",
      utc_offset: "7.00",
      timezone: "Asia/Phnom_Penh",
    },
    {
      id: 47,
      name: "Cameroon",
      code: "CM",
      code_a3: null,
      currency_code: "XAF",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Douala",
    },
    {
      id: 38,
      name: "Canada",
      code: "CA",
      code_a3: null,
      currency_code: "CAD",
      region_name: "North America",
      utc_offset: "-5.00",
      timezone: "America/Toronto",
    },
    {
      id: 52,
      name: "Cape Verde",
      code: "CV",
      code_a3: null,
      currency_code: "CVE",
      region_name: "Africa",
      utc_offset: "-1.00",
      timezone: "Atlantic/Cape_Verde",
    },
    {
      id: 124,
      name: "Cayman Islands",
      code: "KY",
      code_a3: null,
      currency_code: "KYD",
      region_name: "The Caribbean",
      utc_offset: "-5.00",
      timezone: "America/Cayman",
    },
    {
      id: 41,
      name: "Central African Republic",
      code: "CF",
      code_a3: null,
      currency_code: "XAF",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Bangui",
    },
    {
      id: 215,
      name: "Chad",
      code: "TD",
      code_a3: null,
      currency_code: "XAF",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Ndjamena",
    },
    {
      id: 46,
      name: "Chile",
      code: "CL",
      code_a3: null,
      currency_code: "CLP",
      region_name: "South America",
      utc_offset: "-3.00",
      timezone: "America/Santiago",
    },
    {
      id: 48,
      name: "China",
      code: "CN",
      code_a3: null,
      currency_code: "CNY",
      region_name: "Asia",
      utc_offset: "8.00",
      timezone: "Asia/Shanghai",
    },
    {
      id: 54,
      name: "Christmas Island",
      code: "CX",
      code_a3: null,
      currency_code: "AUD",
      region_name: "Other",
      utc_offset: "7.00",
      timezone: "Indian/Christmas",
    },
    {
      id: 39,
      name: "Cocos (Keeling] Islands",
      code: "CC",
      code_a3: null,
      currency_code: "AUD",
      region_name: "Other",
      utc_offset: "6.50",
      timezone: "Indian/Cocos",
    },
    {
      id: 49,
      name: "Colombia",
      code: "CO",
      code_a3: null,
      currency_code: "COP",
      region_name: "South America",
      utc_offset: "-5.00",
      timezone: "America/Bogota",
    },
    {
      id: 119,
      name: "Comoros",
      code: "KM",
      code_a3: null,
      currency_code: "KMF",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Indian/Comoro",
    },
    {
      id: 42,
      name: "Congo",
      code: "CG",
      code_a3: null,
      currency_code: "XAF",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Brazzaville",
    },
    {
      id: 40,
      name: "Congo, the Democratic Republic of the",
      code: "CD",
      code_a3: null,
      currency_code: "CDF",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Brazzaville",
    },
    {
      id: 45,
      name: "Cook Islands",
      code: "CK",
      code_a3: null,
      currency_code: "NZD",
      region_name: "Oceania",
      utc_offset: "-10.00",
      timezone: "Pacific/Rarotonga",
    },
    {
      id: 50,
      name: "Costa Rica",
      code: "CR",
      code_a3: null,
      currency_code: "CRC",
      region_name: "Central America",
      utc_offset: "-6.00",
      timezone: "America/Costa_Rica",
    },
    {
      id: 44,
      name: "Cote dIvoire",
      code: "CI",
      code_a3: null,
      currency_code: "XOF",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Abidjan",
    },
    {
      id: 98,
      name: "Croatia",
      code: "HR",
      code_a3: null,
      currency_code: "HRK",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Zagreb",
    },
    {
      id: 51,
      name: "Cuba",
      code: "CU",
      code_a3: null,
      currency_code: "CUP",
      region_name: "The Caribbean",
      utc_offset: "-5.00",
      timezone: "America/Havana",
    },
    {
      id: 53,
      name: "Curacao",
      code: "CW",
      code_a3: null,
      currency_code: "ANG",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Curacao",
    },
    {
      id: 55,
      name: "Cyprus",
      code: "CY",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Asia/Nicosia",
    },
    {
      id: 56,
      name: "Czech Republic",
      code: "CZ",
      code_a3: null,
      currency_code: "CZK",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Prague",
    },
    {
      id: 59,
      name: "Denmark",
      code: "DK",
      code_a3: null,
      currency_code: "DKK",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Copenhagen",
    },
    {
      id: 58,
      name: "Djibouti",
      code: "DJ",
      code_a3: null,
      currency_code: "DJF",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Africa/Djibouti",
    },
    {
      id: 60,
      name: "Dominica",
      code: "DM",
      code_a3: null,
      currency_code: "XCD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Dominica",
    },
    {
      id: 61,
      name: "Dominican Republic",
      code: "DO",
      code_a3: null,
      currency_code: "DOP",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Santo_Domingo",
    },
    {
      id: 63,
      name: "Ecuador",
      code: "EC",
      code_a3: null,
      currency_code: "USD",
      region_name: "South America",
      utc_offset: "-5.00",
      timezone: "America/Guayaquil",
    },
    {
      id: 65,
      name: "Egypt",
      code: "EG",
      code_a3: null,
      currency_code: "EGP",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Cairo",
    },
    {
      id: 210,
      name: "El Salvador",
      code: "SV",
      code_a3: null,
      currency_code: "USD",
      region_name: "Central America",
      utc_offset: "-6.00",
      timezone: "America/El_Salvador",
    },
    {
      id: 88,
      name: "Equatorial Guinea",
      code: "GQ",
      code_a3: null,
      currency_code: "XAF",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Malabo",
    },
    {
      id: 67,
      name: "Eritrea",
      code: "ER",
      code_a3: null,
      currency_code: "ERN",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Africa/Asmara",
    },
    {
      id: 64,
      name: "Estonia",
      code: "EE",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Tallinn",
    },
    {
      id: 69,
      name: "Ethiopia",
      code: "ET",
      code_a3: null,
      currency_code: "ETB",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Africa/Addis_Ababa",
    },
    {
      id: 72,
      name: "Falkland Islands (Malvinas]",
      code: "FK",
      code_a3: null,
      currency_code: "FKP",
      region_name: "South America",
      utc_offset: "-3.00",
      timezone: "Atlantic/Stanley",
    },
    {
      id: 74,
      name: "Faroe Islands",
      code: "FO",
      code_a3: null,
      currency_code: "DKK",
      region_name: "Europe",
      utc_offset: "0.00",
      timezone: "Atlantic/Faroe",
    },
    {
      id: 71,
      name: "Fiji",
      code: "FJ",
      code_a3: null,
      currency_code: "FJD",
      region_name: "Oceania",
      utc_offset: "13.00",
      timezone: "Pacific/Fiji",
    },
    {
      id: 70,
      name: "Finland",
      code: "FI",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Helsinki",
    },
    {
      id: 75,
      name: "France",
      code: "FR",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Paris",
    },
    {
      id: 80,
      name: "French Guiana",
      code: "GF",
      code_a3: null,
      currency_code: "EUR",
      region_name: "South America",
      utc_offset: "-3.00",
      timezone: "America/Cayenne",
    },
    {
      id: 175,
      name: "French Polynesia",
      code: "PF",
      code_a3: null,
      currency_code: "XPF",
      region_name: "Oceania",
      utc_offset: "-10.00",
      timezone: "Pacific/Tahiti",
    },
    {
      id: 216,
      name: "French Southern Territories",
      code: "TF",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Other",
      utc_offset: "5.00",
      timezone: "Asia/Tashkent",
    },
    {
      id: 76,
      name: "Gabon",
      code: "GA",
      code_a3: null,
      currency_code: "XAF",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Libreville",
    },
    {
      id: 85,
      name: "Gambia",
      code: "GM",
      code_a3: null,
      currency_code: "GMD",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Banjul",
    },
    {
      id: 79,
      name: "Georgia",
      code: "GE",
      code_a3: null,
      currency_code: "GEL",
      region_name: "Asia",
      utc_offset: "4.00",
      timezone: "Asia/Tbilisi",
    },
    {
      id: 57,
      name: "Germany",
      code: "DE",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Berlin",
    },
    {
      id: 82,
      name: "Ghana",
      code: "GH",
      code_a3: null,
      currency_code: "GHC",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Accra",
    },
    {
      id: 83,
      name: "Gibraltar",
      code: "GI",
      code_a3: null,
      currency_code: "GIP",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Gibraltar",
    },
    {
      id: 89,
      name: "Greece",
      code: "GR",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Athens",
    },
    {
      id: 84,
      name: "Greenland",
      code: "GL",
      code_a3: null,
      currency_code: "DKK",
      region_name: "North America",
      utc_offset: "-3.00",
      timezone: "America/Godthab",
    },
    {
      id: 78,
      name: "Grenada",
      code: "GD",
      code_a3: null,
      currency_code: "XCD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Grenada",
    },
    {
      id: 87,
      name: "Guadeloupe",
      code: "GP",
      code_a3: null,
      currency_code: "EUR",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Guadeloupe",
    },
    {
      id: 92,
      name: "Guam",
      code: "GU",
      code_a3: null,
      currency_code: "USD",
      region_name: "Oceania",
      utc_offset: "10.00",
      timezone: "Pacific/Guam",
    },
    {
      id: 91,
      name: "Guatemala",
      code: "GT",
      code_a3: null,
      currency_code: "GTQ",
      region_name: "Central America",
      utc_offset: "-6.00",
      timezone: "America/Guatemala",
    },
    {
      id: 81,
      name: "Guernsey",
      code: "GG",
      code_a3: null,
      currency_code: "GGP",
      region_name: "Europe",
      utc_offset: "0.00",
      timezone: "Europe/Guernsey",
    },
    {
      id: 86,
      name: "Guinea",
      code: "GN",
      code_a3: null,
      currency_code: "GNF",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Conakry",
    },
    {
      id: 93,
      name: "Guinea-Bissau",
      code: "GW",
      code_a3: null,
      currency_code: "GWP",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Bissau",
    },
    {
      id: 94,
      name: "Guyana",
      code: "GY",
      code_a3: null,
      currency_code: "GYD",
      region_name: "South America",
      utc_offset: "-4.00",
      timezone: "America/Guyana",
    },
    {
      id: 99,
      name: "Haiti",
      code: "HT",
      code_a3: null,
      currency_code: "USD",
      region_name: "The Caribbean",
      utc_offset: "-5.00",
      timezone: "America/Port-au-Prince",
    },
    {
      id: 96,
      name: "Heard Island and McDonald Islands",
      code: "HM",
      code_a3: null,
      currency_code: "AUD",
      region_name: "Other",
      utc_offset: "-6.00",
      timezone: "America/Belize",
    },
    {
      id: 236,
      name: "Holy See (Vatican City State]",
      code: "VA",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Vatican",
    },
    {
      id: 97,
      name: "Honduras",
      code: "HN",
      code_a3: null,
      currency_code: "HNL",
      region_name: "Central America",
      utc_offset: "-6.00",
      timezone: "America/Tegucigalpa",
    },
    {
      id: 95,
      name: "Hong Kong",
      code: "HK",
      code_a3: null,
      currency_code: "HKD",
      region_name: "Asia",
      utc_offset: "8.00",
      timezone: "Asia/Hong_Kong",
    },
    {
      id: 100,
      name: "Hungary",
      code: "HU",
      code_a3: null,
      currency_code: "HUF",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Budapest",
    },
    {
      id: 109,
      name: "Iceland",
      code: "IS",
      code_a3: null,
      currency_code: "ISK",
      region_name: "Europe",
      utc_offset: "0.00",
      timezone: "Atlantic/Reykjavik",
    },
    {
      id: 105,
      name: "India",
      code: "IN",
      code_a3: null,
      currency_code: "INR",
      region_name: "Asia",
      utc_offset: "5.50",
      timezone: "Asia/Calcutta",
    },
    {
      id: 101,
      name: "Indonesia",
      code: "ID",
      code_a3: null,
      currency_code: "IDR",
      region_name: "Asia",
      utc_offset: "7.00",
      timezone: "Asia/Jakarta",
    },
    {
      id: 108,
      name: "Iran, Islamic Republic of",
      code: "IR",
      code_a3: null,
      currency_code: "IRR",
      region_name: "Middle East",
      utc_offset: "3.50",
      timezone: "Asia/Tehran",
    },
    {
      id: 107,
      name: "Iraq",
      code: "IQ",
      code_a3: null,
      currency_code: "IQD",
      region_name: "Middle East",
      utc_offset: "3.00",
      timezone: "Asia/Baghdad",
    },
    {
      id: 102,
      name: "Ireland",
      code: "IE",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "0.00",
      timezone: "Europe/Dublin",
    },
    {
      id: 104,
      name: "Isle of Man",
      code: "IM",
      code_a3: null,
      currency_code: "IMP",
      region_name: "Europe",
      utc_offset: "0.00",
      timezone: "Europe/Isle_of_Man",
    },
    {
      id: 103,
      name: "Israel",
      code: "IL",
      code_a3: null,
      currency_code: "ILS",
      region_name: "Middle East",
      utc_offset: "2.00",
      timezone: "Asia/Jerusalem",
    },
    {
      id: 110,
      name: "Italy",
      code: "IT",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Rome",
    },
    {
      id: 112,
      name: "Jamaica",
      code: "JM",
      code_a3: null,
      currency_code: "JMD",
      region_name: "The Caribbean",
      utc_offset: "-5.00",
      timezone: "America/Jamaica",
    },
    {
      id: 114,
      name: "Japan",
      code: "JP",
      code_a3: null,
      currency_code: "JPY",
      region_name: "Asia",
      utc_offset: "9.00",
      timezone: "Asia/Tokyo",
    },
    {
      id: 111,
      name: "Jersey",
      code: "JE",
      code_a3: null,
      currency_code: "JEP",
      region_name: "Europe",
      utc_offset: "0.00",
      timezone: "Europe/Jersey",
    },
    {
      id: 113,
      name: "Jordan",
      code: "JO",
      code_a3: null,
      currency_code: "JOD",
      region_name: "Middle East",
      utc_offset: "2.00",
      timezone: "Asia/Amman",
    },
    {
      id: 125,
      name: "Kazakhstan",
      code: "KZ",
      code_a3: null,
      currency_code: "KZT",
      region_name: "Asia",
      utc_offset: "6.00",
      timezone: "Asia/Almaty",
    },
    {
      id: 115,
      name: "Kenya",
      code: "KE",
      code_a3: null,
      currency_code: "KES",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Africa/Nairobi",
    },
    {
      id: 118,
      name: "Kiribati",
      code: "KI",
      code_a3: null,
      currency_code: "AUD",
      region_name: "Oceania",
      utc_offset: "12.00",
      timezone: "Pacific/Tarawa",
    },
    {
      id: 121,
      name: "Korea, Democratic People's Republic of",
      code: "KP",
      code_a3: null,
      currency_code: "KPW",
      region_name: "Asia",
      utc_offset: "8.50",
      timezone: "Asia/Pyongyang",
    },
    {
      id: 122,
      name: "Korea, Republic of",
      code: "KR",
      code_a3: null,
      currency_code: "KRW",
      region_name: "Asia",
      utc_offset: "9.00",
      timezone: "Asia/Seoul",
    },
    {
      id: 123,
      name: "Kuwait",
      code: "KW",
      code_a3: null,
      currency_code: "KWD",
      region_name: "Middle East",
      utc_offset: "3.00",
      timezone: "Asia/Kuwait",
    },
    {
      id: 116,
      name: "Kyrgyzstan",
      code: "KG",
      code_a3: null,
      currency_code: "KGS",
      region_name: "Asia",
      utc_offset: "6.00",
      timezone: "Asia/Bishkek",
    },
    {
      id: 126,
      name: "Lao People's Democratic Republic",
      code: "LA",
      code_a3: null,
      currency_code: "LAK",
      region_name: "Asia",
      utc_offset: "7.00",
      timezone: "Asia/Vientiane",
    },
    {
      id: 135,
      name: "Latvia",
      code: "LV",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Riga",
    },
    {
      id: 127,
      name: "Lebanon",
      code: "LB",
      code_a3: null,
      currency_code: "LBP",
      region_name: "Middle East",
      utc_offset: "2.00",
      timezone: "Asia/Beirut",
    },
    {
      id: 132,
      name: "Lesotho",
      code: "LS",
      code_a3: null,
      currency_code: "LSL",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Maseru",
    },
    {
      id: 131,
      name: "Liberia",
      code: "LR",
      code_a3: null,
      currency_code: "LRD",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Monrovia",
    },
    {
      id: 136,
      name: "Libyan Arab Jamahiriya",
      code: "LY",
      code_a3: null,
      currency_code: "LYD",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Tripoli",
    },
    {
      id: 129,
      name: "Liechtenstein",
      code: "LI",
      code_a3: null,
      currency_code: "CHF",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Vaduz",
    },
    {
      id: 133,
      name: "Lithuania",
      code: "LT",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Vilnius",
    },
    {
      id: 134,
      name: "Luxembourg",
      code: "LU",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Luxembourg",
    },
    {
      id: 148,
      name: "Macao",
      code: "MO",
      code_a3: null,
      currency_code: "MOP",
      region_name: "Asia",
      utc_offset: "8.00",
      timezone: "Asia/Macau",
    },
    {
      id: 144,
      name: "Macedonia, the former Yugoslav Republic of",
      code: "MK",
      code_a3: null,
      currency_code: "MKD",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Skopje",
    },
    {
      id: 142,
      name: "Madagascar",
      code: "MG",
      code_a3: null,
      currency_code: "MGF",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Indian/Antananarivo",
    },
    {
      id: 156,
      name: "Malawi",
      code: "MW",
      code_a3: null,
      currency_code: "MWK",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Maputo",
    },
    {
      id: 158,
      name: "Malaysia",
      code: "MY",
      code_a3: null,
      currency_code: "MYR",
      region_name: "Asia",
      utc_offset: "8.00",
      timezone: "Asia/Kuala_Lumpur",
    },
    {
      id: 155,
      name: "Maldives",
      code: "MV",
      code_a3: null,
      currency_code: "MVR",
      region_name: "Asia",
      utc_offset: "5.00",
      timezone: "Indian/Maldives",
    },
    {
      id: 145,
      name: "Mali",
      code: "ML",
      code_a3: null,
      currency_code: "XOF",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Bamako",
    },
    {
      id: 153,
      name: "Malta",
      code: "MT",
      code_a3: null,
      currency_code: "MTL",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Malta",
    },
    {
      id: 143,
      name: "Marshall Islands",
      code: "MH",
      code_a3: null,
      currency_code: "USD",
      region_name: "Oceania",
      utc_offset: "12.00",
      timezone: "Pacific/Kwajalein",
    },
    {
      id: 150,
      name: "Martinique",
      code: "MQ",
      code_a3: null,
      currency_code: "EUR",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Martinique",
    },
    {
      id: 151,
      name: "Mauritania",
      code: "MR",
      code_a3: null,
      currency_code: "MRO",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Nouakchott",
    },
    {
      id: 154,
      name: "Mauritius",
      code: "MU",
      code_a3: null,
      currency_code: "MUR",
      region_name: "Africa",
      utc_offset: "4.00",
      timezone: "Indian/Mauritius",
    },
    {
      id: 246,
      name: "Mayotte",
      code: "YT",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Indian/Mayotte",
    },
    {
      id: 157,
      name: "Mexico",
      code: "MX",
      code_a3: null,
      currency_code: "MXN",
      region_name: "Central America",
      utc_offset: "-6.00",
      timezone: "America/Mexico_City",
    },
    {
      id: 73,
      name: "Micronesia, Federated States of",
      code: "FM",
      code_a3: null,
      currency_code: "USD",
      region_name: "Oceania",
      utc_offset: "11.00",
      timezone: "Pacific/Ponape",
    },
    {
      id: 139,
      name: "Moldova, Republic of",
      code: "MD",
      code_a3: null,
      currency_code: "MDL",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Chisinau",
    },
    {
      id: 138,
      name: "Monaco",
      code: "MC",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Monaco",
    },
    {
      id: 147,
      name: "Mongolia",
      code: "MN",
      code_a3: null,
      currency_code: "MNT",
      region_name: "Asia",
      utc_offset: "8.00",
      timezone: "Asia/Ulaanbaatar",
    },
    {
      id: 140,
      name: "Montenegro",
      code: "ME",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Podgorica",
    },
    {
      id: 152,
      name: "Montserrat",
      code: "MS",
      code_a3: null,
      currency_code: "XCD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Montserrat",
    },
    {
      id: 137,
      name: "Morocco",
      code: "MA",
      code_a3: null,
      currency_code: "MAD",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Casablanca",
    },
    {
      id: 159,
      name: "Mozambique",
      code: "MZ",
      code_a3: null,
      currency_code: "MZM",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Maputo",
    },
    {
      id: 146,
      name: "Myanmar",
      code: "MM",
      code_a3: null,
      currency_code: "MMK",
      region_name: "Asia",
      utc_offset: "6.50",
      timezone: "Asia/Rangoon",
    },
    {
      id: 160,
      name: "Namibia",
      code: "NA",
      code_a3: null,
      currency_code: "ZAR",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Windhoek",
    },
    {
      id: 169,
      name: "Nauru",
      code: "NR",
      code_a3: null,
      currency_code: "AUD",
      region_name: "Oceania",
      utc_offset: "12.00",
      timezone: "Pacific/Nauru",
    },
    {
      id: 168,
      name: "Nepal",
      code: "NP",
      code_a3: null,
      currency_code: "NPR",
      region_name: "Asia",
      utc_offset: "5.75",
      timezone: "Asia/Kathmandu",
    },
    {
      id: 166,
      name: "Netherlands",
      code: "NL",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Amsterdam",
    },
    {
      id: 161,
      name: "New Caledonia",
      code: "NC",
      code_a3: null,
      currency_code: "XPF",
      region_name: "Oceania",
      utc_offset: "11.00",
      timezone: "Pacific/Noumea",
    },
    {
      id: 171,
      name: "New Zealand",
      code: "NZ",
      code_a3: null,
      currency_code: "NZD",
      region_name: "Oceania",
      utc_offset: "13.00",
      timezone: "Pacific/Auckland",
    },
    {
      id: 165,
      name: "Nicaragua",
      code: "NI",
      code_a3: null,
      currency_code: "NIO",
      region_name: "Central America",
      utc_offset: "-6.00",
      timezone: "America/Managua",
    },
    {
      id: 162,
      name: "Niger",
      code: "NE",
      code_a3: null,
      currency_code: "XOF",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Niamey",
    },
    {
      id: 164,
      name: "Nigeria",
      code: "NG",
      code_a3: null,
      currency_code: "NGN",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Lagos",
    },
    {
      id: 170,
      name: "Niue",
      code: "NU",
      code_a3: null,
      currency_code: "NZD",
      region_name: "Oceania",
      utc_offset: "-11.00",
      timezone: "Pacific/Niue",
    },
    {
      id: 163,
      name: "Norfolk Island",
      code: "NF",
      code_a3: null,
      currency_code: "AUD",
      region_name: "Oceania",
      utc_offset: "11.50",
      timezone: "Pacific/Norfolk",
    },
    {
      id: 149,
      name: "Northern Mariana Islands",
      code: "MP",
      code_a3: null,
      currency_code: "USD",
      region_name: "Oceania",
      utc_offset: "10.00",
      timezone: "Pacific/Saipan",
    },
    {
      id: 167,
      name: "Norway",
      code: "NO",
      code_a3: null,
      currency_code: "NOK",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Oslo",
    },
    {
      id: 172,
      name: "Oman",
      code: "OM",
      code_a3: null,
      currency_code: "OMR",
      region_name: "Middle East",
      utc_offset: "4.00",
      timezone: "Asia/Muscat",
    },
    {
      id: 178,
      name: "Pakistan",
      code: "PK",
      code_a3: null,
      currency_code: "PKR",
      region_name: "Asia",
      utc_offset: "5.00",
      timezone: "Asia/Karachi",
    },
    {
      id: 185,
      name: "Palau",
      code: "PW",
      code_a3: null,
      currency_code: "USD",
      region_name: "Oceania",
      utc_offset: "9.00",
      timezone: "Pacific/Palau",
    },
    {
      id: 183,
      name: "Palestinian Territory, Occupied",
      code: "PS",
      code_a3: null,
      currency_code: "EGP",
      region_name: "Middle East",
      utc_offset: "2.00",
      timezone: "Asia/Gaza",
    },
    {
      id: 173,
      name: "Panama",
      code: "PA",
      code_a3: null,
      currency_code: "USD",
      region_name: "Central America",
      utc_offset: "-5.00",
      timezone: "America/Panama",
    },
    {
      id: 176,
      name: "Papua New Guinea",
      code: "PG",
      code_a3: null,
      currency_code: "PGK",
      region_name: "Oceania",
      utc_offset: "10.00",
      timezone: "Pacific/Port_Moresby",
    },
    {
      id: 186,
      name: "Paraguay",
      code: "PY",
      code_a3: null,
      currency_code: "PYG",
      region_name: "South America",
      utc_offset: "-3.00",
      timezone: "America/Asuncion",
    },
    {
      id: 174,
      name: "Peru",
      code: "PE",
      code_a3: null,
      currency_code: "PEN",
      region_name: "South America",
      utc_offset: "-5.00",
      timezone: "America/Lima",
    },
    {
      id: 177,
      name: "Philippines",
      code: "PH",
      code_a3: null,
      currency_code: "PHP",
      region_name: "Asia",
      utc_offset: "8.00",
      timezone: "Asia/Manila",
    },
    {
      id: 181,
      name: "Pitcairn",
      code: "PN",
      code_a3: null,
      currency_code: "NZD",
      region_name: "Oceania",
      utc_offset: "-8.00",
      timezone: "Pacific/Pitcairn",
    },
    {
      id: 179,
      name: "Poland",
      code: "PL",
      code_a3: null,
      currency_code: "PLN",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Warsaw",
    },
    {
      id: 184,
      name: "Portugal",
      code: "PT",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "0.00",
      timezone: "Europe/Lisbon",
    },
    {
      id: 182,
      name: "Puerto Rico",
      code: "PR",
      code_a3: null,
      currency_code: "USD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Puerto_Rico",
    },
    {
      id: 187,
      name: "Qatar",
      code: "QA",
      code_a3: null,
      currency_code: "QAR",
      region_name: "Middle East",
      utc_offset: "3.00",
      timezone: "Asia/Qatar",
    },
    {
      id: 188,
      name: "Reunion",
      code: "RE",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Africa",
      utc_offset: "4.00",
      timezone: "Indian/Reunion",
    },
    {
      id: 189,
      name: "Romania",
      code: "RO",
      code_a3: null,
      currency_code: "ROL",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Bucharest",
    },
    {
      id: 191,
      name: "Russian Federation",
      code: "RU",
      code_a3: null,
      currency_code: "RUB",
      region_name: "Europe",
      utc_offset: "3.00",
      timezone: "Europe/Moscow",
    },
    {
      id: 192,
      name: "Rwanda",
      code: "RW",
      code_a3: null,
      currency_code: "RWF",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Kigali",
    },
    {
      id: 26,
      name: "Saint Barthelemy",
      code: "BL",
      code_a3: null,
      currency_code: "EUR",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/St_Barthelemy",
    },
    {
      id: 199,
      name: "Saint Helena, Ascension and Tristan da Cunha",
      code: "SH",
      code_a3: null,
      currency_code: "SHP",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Atlantic/St_Helena",
    },
    {
      id: 120,
      name: "Saint Kitts and Nevis",
      code: "KN",
      code_a3: null,
      currency_code: "XCD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/St_Kitts",
    },
    {
      id: 128,
      name: "Saint Lucia",
      code: "LC",
      code_a3: null,
      currency_code: "XCD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/St_Lucia",
    },
    {
      id: 141,
      name: "Saint Martin (French part]",
      code: "MF",
      code_a3: null,
      currency_code: "EUR",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Anguilla",
    },
    {
      id: 180,
      name: "Saint Pierre and Miquelon",
      code: "PM",
      code_a3: null,
      currency_code: "EUR",
      region_name: "North America",
      utc_offset: "-3.00",
      timezone: "America/Miquelon",
    },
    {
      id: 237,
      name: "Saint Vincent and the Grenadines",
      code: "VC",
      code_a3: null,
      currency_code: "XCD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/St_Vincent",
    },
    {
      id: 244,
      name: "Samoa",
      code: "WS",
      code_a3: null,
      currency_code: "WST",
      region_name: "Oceania",
      utc_offset: "-11.00",
      timezone: "Pacific/Samoa",
    },
    {
      id: 204,
      name: "San Marino",
      code: "SM",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/San_Marino",
    },
    {
      id: 209,
      name: "Sao Tome and Principe",
      code: "ST",
      code_a3: null,
      currency_code: "STD",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Sao_Tome",
    },
    {
      id: 193,
      name: "Saudi Arabia",
      code: "SA",
      code_a3: null,
      currency_code: "SAR",
      region_name: "Middle East",
      utc_offset: "3.00",
      timezone: "Asia/Riyadh",
    },
    {
      id: 205,
      name: "Senegal",
      code: "SN",
      code_a3: null,
      currency_code: "XOF",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Dakar",
    },
    {
      id: 190,
      name: "Serbia",
      code: "RS",
      code_a3: null,
      currency_code: "CSD",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Belgrade",
    },
    {
      id: 195,
      name: "Seychelles",
      code: "SC",
      code_a3: null,
      currency_code: "SCR",
      region_name: "Africa",
      utc_offset: "4.00",
      timezone: "Indian/Reunion",
    },
    {
      id: 203,
      name: "Sierra Leone",
      code: "SL",
      code_a3: null,
      currency_code: "SLL",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Freetown",
    },
    {
      id: 198,
      name: "Singapore",
      code: "SG",
      code_a3: null,
      currency_code: "SGD",
      region_name: "Asia",
      utc_offset: "8.00",
      timezone: "Asia/Singapore",
    },
    {
      id: 211,
      name: "Sint Maarten",
      code: "SX",
      code_a3: null,
      currency_code: "ANG",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Anguilla",
    },
    {
      id: 202,
      name: "Slovakia",
      code: "SK",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Bratislava",
    },
    {
      id: 200,
      name: "Slovenia",
      code: "SI",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Ljubljana",
    },
    {
      id: 194,
      name: "Solomon Islands",
      code: "SB",
      code_a3: null,
      currency_code: "SBD",
      region_name: "Oceania",
      utc_offset: "11.00",
      timezone: "Pacific/Guadalcanal",
    },
    {
      id: 206,
      name: "Somalia",
      code: "SO",
      code_a3: null,
      currency_code: "SOS",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Africa/Mogadishu",
    },
    {
      id: 247,
      name: "South Africa",
      code: "ZA",
      code_a3: null,
      currency_code: "ZAR",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Johannesburg",
    },
    {
      id: 90,
      name: "South Georgia and the South Sandwich Islands",
      code: "GS",
      code_a3: null,
      currency_code: "GBP",
      region_name: "Other",
      utc_offset: "-2.00",
      timezone: "Atlantic/South_Georgia",
    },
    {
      id: 208,
      name: "South Sudan",
      code: "SS",
      code_a3: null,
      currency_code: "SSP",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Africa/Juba",
    },
    {
      id: 68,
      name: "Spain",
      code: "ES",
      code_a3: null,
      currency_code: "EUR",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Madrid",
    },
    {
      id: 130,
      name: "Sri Lanka",
      code: "LK",
      code_a3: null,
      currency_code: "LKR",
      region_name: "Asia",
      utc_offset: "5.50",
      timezone: "Asia/Colombo",
    },
    {
      id: 196,
      name: "Sudan",
      code: "SD",
      code_a3: null,
      currency_code: "SDG",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Africa/Khartoum",
    },
    {
      id: 207,
      name: "Suriname",
      code: "SR",
      code_a3: null,
      currency_code: "SRG",
      region_name: "South America",
      utc_offset: "-3.00",
      timezone: "America/Paramaribo",
    },
    {
      id: 201,
      name: "Svalbard and Jan Mayen",
      code: "SJ",
      code_a3: null,
      currency_code: "NOK",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Atlantic/Jan_Mayen",
    },
    {
      id: 213,
      name: "Swaziland",
      code: "SZ",
      code_a3: null,
      currency_code: "SZL",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Mbabane",
    },
    {
      id: 197,
      name: "Sweden",
      code: "SE",
      code_a3: null,
      currency_code: "SEK",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Stockholm",
    },
    {
      id: 43,
      name: "Switzerland",
      code: "CH",
      code_a3: null,
      currency_code: "CHF",
      region_name: "Europe",
      utc_offset: "1.00",
      timezone: "Europe/Zurich",
    },
    {
      id: 212,
      name: "Syrian Arab Republic",
      code: "SY",
      code_a3: null,
      currency_code: "SYP",
      region_name: "Middle East",
      utc_offset: "2.00",
      timezone: "Asia/Damascus",
    },
    {
      id: 228,
      name: "Taiwan, Province of China",
      code: "TW",
      code_a3: null,
      currency_code: "TWD",
      region_name: "Asia",
      utc_offset: "8.00",
      timezone: "Asia/Taipei",
    },
    {
      id: 219,
      name: "Tajikistan",
      code: "TJ",
      code_a3: null,
      currency_code: "TJS",
      region_name: "Asia",
      utc_offset: "5.00",
      timezone: "Asia/Dushanbe",
    },
    {
      id: 229,
      name: "Tanzania, United Republic of",
      code: "TZ",
      code_a3: null,
      currency_code: "TZS",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Africa/Dar_es_Salaam",
    },
    {
      id: 218,
      name: "Thailand",
      code: "TH",
      code_a3: null,
      currency_code: "THB",
      region_name: "Asia",
      utc_offset: "7.00",
      timezone: "Asia/Bangkok",
    },
    {
      id: 221,
      name: "Timor-Leste",
      code: "TL",
      code_a3: null,
      currency_code: "USD",
      region_name: "Asia",
      utc_offset: "9.00",
      timezone: "Asia/Dili",
    },
    {
      id: 217,
      name: "Togo",
      code: "TG",
      code_a3: null,
      currency_code: "XOF",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/Lome",
    },
    {
      id: 220,
      name: "Tokelau",
      code: "TK",
      code_a3: null,
      currency_code: "NZD",
      region_name: "Oceania",
      utc_offset: "13.00",
      timezone: "Pacific/Fakaofo",
    },
    {
      id: 224,
      name: "Tonga",
      code: "TO",
      code_a3: null,
      currency_code: "TOP",
      region_name: "Oceania",
      utc_offset: "13.00",
      timezone: "Pacific/Tongatapu",
    },
    {
      id: 226,
      name: "Trinidad and Tobago",
      code: "TT",
      code_a3: null,
      currency_code: "TTD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Port_of_Spain",
    },
    {
      id: 223,
      name: "Tunisia",
      code: "TN",
      code_a3: null,
      currency_code: "TND",
      region_name: "Africa",
      utc_offset: "1.00",
      timezone: "Africa/Tunis",
    },
    {
      id: 225,
      name: "Turkey",
      code: "TR",
      code_a3: null,
      currency_code: "TRY",
      region_name: "Asia",
      utc_offset: "2.00",
      timezone: "Europe/Istanbul",
    },
    {
      id: 222,
      name: "Turkmenistan",
      code: "TM",
      code_a3: null,
      currency_code: "TMM",
      region_name: "Asia",
      utc_offset: "5.00",
      timezone: "Asia/Ashgabat",
    },
    {
      id: 214,
      name: "Turks and Caicos Islands",
      code: "TC",
      code_a3: null,
      currency_code: "USD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Grand_Turk",
    },
    {
      id: 227,
      name: "Tuvalu",
      code: "TV",
      code_a3: null,
      currency_code: "AUD",
      region_name: "Oceania",
      utc_offset: "12.00",
      timezone: "Pacific/Funafuti",
    },
    {
      id: 231,
      name: "Uganda",
      code: "UG",
      code_a3: null,
      currency_code: "UGX",
      region_name: "Africa",
      utc_offset: "3.00",
      timezone: "Africa/Kampala",
    },
    {
      id: 230,
      name: "Ukraine",
      code: "UA",
      code_a3: null,
      currency_code: "UAH",
      region_name: "Europe",
      utc_offset: "2.00",
      timezone: "Europe/Kiev",
    },
    {
      id: 2,
      name: "United Arab Emirates",
      code: "AE",
      code_a3: null,
      currency_code: "AED",
      region_name: "Middle East",
      utc_offset: "4.00",
      timezone: "Asia/Dubai",
    },
    {
      id: 77,
      name: "United Kingdom",
      code: "GB",
      code_a3: null,
      currency_code: "GBP",
      region_name: "Europe",
      utc_offset: "0.00",
      timezone: "Europe/London",
    },
    {
      id: 233,
      name: "United States",
      code: "US",
      code_a3: null,
      currency_code: "USD",
      region_name: "North America",
      utc_offset: "-5.00",
      timezone: "America/New_York",
    },
    {
      id: 232,
      name: "United States Minor Outlying Islands",
      code: "UM",
      code_a3: null,
      currency_code: "USD",
      region_name: "Other",
      utc_offset: "-11.00",
      timezone: "Pacific/Midway",
    },
    {
      id: 234,
      name: "Uruguay",
      code: "UY",
      code_a3: null,
      currency_code: "UYU",
      region_name: "South America",
      utc_offset: "-3.00",
      timezone: "America/Montevideo",
    },
    {
      id: 235,
      name: "Uzbekistan",
      code: "UZ",
      code_a3: null,
      currency_code: "UZS",
      region_name: "Asia",
      utc_offset: "5.00",
      timezone: "Asia/Tashkent",
    },
    {
      id: 242,
      name: "Vanuatu",
      code: "VU",
      code_a3: null,
      currency_code: "VUV",
      region_name: "Oceania",
      utc_offset: "11.00",
      timezone: "Pacific/Efate",
    },
    {
      id: 238,
      name: "Venezuela, Bolivarian Republic of",
      code: "VE",
      code_a3: null,
      currency_code: "VEF",
      region_name: "South America",
      utc_offset: "-4.50",
      timezone: "America/Caracas",
    },
    {
      id: 241,
      name: "Viet Nam",
      code: "VN",
      code_a3: null,
      currency_code: "VND",
      region_name: "Asia",
      utc_offset: "7.00",
      timezone: "Asia/Ho_Chi_Minh",
    },
    {
      id: 239,
      name: "Virgin Islands, British",
      code: "VG",
      code_a3: null,
      currency_code: "USD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Virgin",
    },
    {
      id: 240,
      name: "Virgin Islands, U.S.",
      code: "VI",
      code_a3: null,
      currency_code: "USD",
      region_name: "The Caribbean",
      utc_offset: "-4.00",
      timezone: "America/Virgin",
    },
    {
      id: 243,
      name: "Wallis and Futuna",
      code: "WF",
      code_a3: null,
      currency_code: "XPF",
      region_name: "Oceania",
      utc_offset: "12.00",
      timezone: "Pacific/Wallis",
    },
    {
      id: 66,
      name: "Western Sahara",
      code: "EH",
      code_a3: null,
      currency_code: "MAD",
      region_name: "Africa",
      utc_offset: "0.00",
      timezone: "Africa/El_Aaiun",
    },
    {
      id: 245,
      name: "Yemen",
      code: "YE",
      code_a3: null,
      currency_code: "YER",
      region_name: "Middle East",
      utc_offset: "3.00",
      timezone: "Asia/Aden",
    },
    {
      id: 248,
      name: "Zambia",
      code: "ZM",
      code_a3: null,
      currency_code: "ZMK",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Lusaka",
    },
    {
      id: 249,
      name: "Zimbabwe",
      code: "ZW",
      code_a3: null,
      currency_code: "ZWD",
      region_name: "Africa",
      utc_offset: "2.00",
      timezone: "Africa/Harare",
    },
  ],
  retailers: [
    {
      id: 1,
      name: "7 Digital",
      display_name: "7 Digital",
      image:
        "https://empiredi-sb-file.s3-accelerate.amazonaws.com/retailers/80/retailer-c4ca4238a0b923820dcc509a6f75849b.jpg",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 1,
      xml_version_label: "DDEX 3.8.2",
      uuid: "PADPIDA343434",
      options_attributes: {
        download: false,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: false,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: true,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: false,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: true,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: false,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: false,
        cover_art_preview_start_date: false,
        included_in_analytic_details: false,
        track_listing_preview_start_date: false,
      },
      created_at: null,
      updated_at: "2025-01-16T15:07:50.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "22",
        type: 2,
        server: "3.82.143.185",
        password: "**********",
        username: "administrator",
        directory: "supplychain",
        public_key: null,
        type_label: "SFTP Password",
      },
    },
    {
      id: 9,
      name: "Amazon (TEST)",
      display_name: "Amazon (TEST)",
      image:
        "https://empiredi-sb-file.s3-accelerate.amazonaws.com/retailers/80/retailer-45c48cce2e2d7fbdea1afc51c7c6ad26.jpg",
      notes: null,
      status: 1,
      status_label: "Active",
      website: "https://www.amazon.com/",
      xml_version: 1,
      xml_version_label: "DDEX 3.8.2",
      uuid: "PADPIDA343434",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: true,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: false,
        syndicates_ringtones: false,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: true,
        allow_partial_uploads: false,
        included_in_analytics: true,
        accepts_dolby_products: true,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: true,
        track_listing_preview_start_date: true,
      },
      created_at: null,
      updated_at: "2025-03-03T14:06:10.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "1412",
        type: 1,
        server: "54.81.242.108",
        password: "**********",
        username: "empire-test",
        directory: "supplychain",
        public_key: null,
        type_label: "FTP",
      },
    },
    {
      id: 26,
      name: "Apple Music Videos (TEST)",
      display_name: "Apple Music Videos (TEST)",
      image:
        "https://empiredi-sb-file.s3-accelerate.amazonaws.com/retailers/80/retailer-2a38a4a9316c49e5a833517c45d31070.jpg",
      notes: null,
      status: 1,
      status_label: "Active",
      website: "https://www.apple.com",
      xml_version: 3,
      xml_version_label: "Music5.3",
      uuid: "PADPIDA343434",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: false,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: false,
        syndicates_videos: true,
        syndicates_ringtones: false,
        unchecked_by_default: false,
        uses_specific_genres: true,
        accepts_preview_clips: false,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: false,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: false,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: false,
        cover_art_preview_start_date: false,
        included_in_analytic_details: false,
        track_listing_preview_start_date: false,
      },
      created_at: null,
      updated_at: "2025-04-03T15:47:01.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        name: "testmusicprovider",
        type: 7,
        password: "**********",
        username: "transporter@supplychainmusic.com",
        public_key: null,
        type_label: "Itunes Transporter",
      },
    },
    {
      id: 27,
      name: "Apple Music",
      display_name: "Apple Music",
      image:
        "https://empiredi-sb-file.s3-accelerate.amazonaws.com/retailers/80/retailer-02e74f10e0327ad868d138f2b4fdd6f0.jpg",
      notes: null,
      status: 1,
      status_label: "Active",
      website: "https://www.apple.com",
      xml_version: 3,
      xml_version_label: "Music5.3",
      uuid: "PADPIDA343434",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: true,
        accepts_preorder: false,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: true,
        unchecked_by_default: false,
        uses_specific_genres: true,
        accepts_preview_clips: false,
        allow_partial_uploads: false,
        included_in_analytics: true,
        accepts_dolby_products: false,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: false,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: false,
        cover_art_preview_start_date: false,
        included_in_analytic_details: true,
        track_listing_preview_start_date: false,
      },
      created_at: null,
      updated_at: "2024-11-08T14:49:27.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        name: "testmusicprovider",
        type: 7,
        password: "**********",
        username: "transporter@supplychainmusic.com",
        public_key: null,
        type_label: "Itunes Transporter",
      },
    },
    {
      id: 31,
      name: "Audiomack (TEST)",
      display_name: "Audiomack (TEST)",
      image:
        "https://empiredi-sb-file.s3-accelerate.amazonaws.com/retailers/80/retailer-c16a5320fa475530d9583c34fd356ef5.jpg",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 2,
      xml_version_label: "DDEX 4.3",
      uuid: "PADPIDA343434",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: true,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: false,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: true,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: true,
        accepts_timed_releases: true,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: false,
        track_listing_preview_start_date: true,
      },
      created_at: null,
      updated_at: "2025-02-05T08:53:59.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "21",
        type: 1,
        server: "3.82.143.185",
        password: "**********",
        username: "empire-test",
        directory: "supplychain",
        public_key: null,
        type_label: "FTP",
      },
    },
    {
      id: 88,
      name: "Apple iTunes (TEST)",
      display_name: "Apple iTunes (TEST)",
      image:
        "https://empiredi-sb-file.s3-accelerate.amazonaws.com/retailers/80/retailer-2a38a4a9316c49e5a833517c45d31070.jpg",
      notes: null,
      status: 1,
      status_label: "Active",
      website: "https://www.apple.com/itunes/",
      xml_version: 3,
      xml_version_label: "Music5.3",
      uuid: "PADPIDA343434",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: true,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: false,
        syndicates_ringtones: false,
        unchecked_by_default: false,
        uses_specific_genres: true,
        accepts_preview_clips: true,
        allow_partial_uploads: false,
        included_in_analytics: true,
        accepts_dolby_products: false,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: false,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: false,
        cover_art_preview_start_date: false,
        included_in_analytic_details: true,
        track_listing_preview_start_date: false,
      },
      created_at: null,
      updated_at: "2025-04-03T15:24:49.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        name: "testmusicprovider",
        type: 7,
        password: "**********",
        username: "transporter@supplychainmusic.com",
        public_key: null,
        type_label: "Itunes Transporter",
      },
    },
    {
      id: 157,
      name: "Spotify",
      display_name: "Spotify",
      image:
        "https://empiredi-sb-file.s3-accelerate.amazonaws.com/retailers/80/retailer-6c4b761a28b734fe93831e3fb400ce87.jpg",
      notes: null,
      status: 1,
      status_label: "Active",
      website: "https://www.spotify.com",
      xml_version: 2,
      xml_version_label: "DDEX 4.3",
      uuid: "PADPIDA343434",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: true,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: true,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: true,
        allow_partial_uploads: false,
        included_in_analytics: true,
        accepts_dolby_products: true,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: false,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: false,
        cover_art_preview_start_date: false,
        included_in_analytic_details: true,
        track_listing_preview_start_date: false,
      },
      created_at: null,
      updated_at: "2024-11-12T14:25:12.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "22",
        type: 4,
        server: "s-58795eb3bd434670b.server.transfer.us-west-1.amazonaws.com",
        username: "aboveall-app",
        directory: "supplychain",
        public_key: null,
        type_label: "SFTP Private Key",
        private_key: "**********",
      },
    },
    {
      id: 218,
      name: "AV",
      display_name: "AV",
      image: "https://empiredi-sb-file.s3-accelerate.amazonaws.com/150.png",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 2,
      xml_version_label: "DDEX 4.3",
      uuid: "PADPIDA343434",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: true,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: true,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: true,
        unchecked_by_default: false,
        uses_specific_genres: true,
        accepts_preview_clips: true,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: true,
        accepts_timed_releases: true,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: false,
        track_listing_preview_start_date: true,
      },
      created_at: "2024-10-18T13:21:46.000000Z",
      updated_at: "2024-11-08T15:22:39.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "21",
        type: 1,
        server: "3.82.143.185",
        password: "**********",
        username: "empire-test",
        directory: "supplychain",
        public_key: null,
        type_label: "FTP",
      },
    },
    {
      id: 222,
      name: "3.8.2 n.s.t",
      display_name: "test lika",
      image: "https://empiredi-sb-file.s3-accelerate.amazonaws.com/150.png",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 1,
      xml_version_label: "DDEX 3.8.2",
      uuid: "PADPIDA343434",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: true,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: true,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: false,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: false,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: false,
        track_listing_preview_start_date: true,
      },
      created_at: "2024-10-22T14:07:49.000000Z",
      updated_at: "2025-03-18T18:29:20.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "1412",
        type: 1,
        server: "54.81.242.108",
        password: "**********",
        username: "empire-test",
        directory: "somefolder",
        public_key: null,
        type_label: "FTP",
      },
    },
    {
      id: 223,
      name: "4.3 n.s.t",
      display_name: "test lika",
      image: "https://empiredi-sb-file.s3-accelerate.amazonaws.com/150.png",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 2,
      xml_version_label: "DDEX 4.3",
      uuid: "PADPIDAm2op530l",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: false,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: true,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: false,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: true,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: false,
        track_listing_preview_start_date: true,
      },
      created_at: "2024-10-25T12:16:30.000000Z",
      updated_at: "2025-03-14T12:03:56.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "1412",
        type: 1,
        server: "54.81.242.108",
        password: "**********",
        username: "empire-test",
        directory: "somefolder",
        public_key: null,
        type_label: "FTP",
      },
    },
    {
      id: 224,
      name: "3.8.2 s.t",
      display_name: "Retailer GL C smoke",
      image: "https://empiredi-sb-file.s3-accelerate.amazonaws.com/150.png",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 1,
      xml_version_label: "DDEX 3.8.2",
      uuid: "PADPIDAm38rwhp3",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: true,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: true,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: true,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: true,
        accepts_timed_releases: true,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: false,
        track_listing_preview_start_date: true,
      },
      created_at: "2024-11-08T13:29:16.000000Z",
      updated_at: "2025-03-14T12:24:48.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "1412",
        type: 1,
        server: "54.81.242.108",
        password: "**********",
        username: "empire-test",
        directory: "somefolder",
        public_key: null,
        type_label: "FTP",
      },
    },
    {
      id: 225,
      name: "4.3 s.t",
      display_name: "4.3 s.t",
      image: "https://empiredi-sb-file.s3-accelerate.amazonaws.com/150.png",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 2,
      xml_version_label: "DDEX 4.3",
      uuid: "PADPIDAm38sdg8i",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: true,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: true,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: true,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: false,
        accepts_timed_releases: true,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: false,
        track_listing_preview_start_date: true,
      },
      created_at: "2024-11-08T13:42:28.000000Z",
      updated_at: "2025-04-03T16:03:50.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "1412",
        type: 1,
        server: "54.81.242.108",
        password: "**********",
        username: "empire-test",
        directory: "somefolder",
        public_key: null,
        type_label: "FTP",
      },
    },
    {
      id: 227,
      name: "Amazon Music Videos (TEST)",
      display_name: "Amazon Music Videos (TEST)",
      image: "https://empiredi-sb-file.s3-accelerate.amazonaws.com/150.png",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 1,
      xml_version_label: "DDEX 3.8.2",
      uuid: "PADPIDAm6rmhayd",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: false,
        accepts_preorder: false,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: false,
        syndicates_videos: true,
        syndicates_ringtones: false,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: false,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: false,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: false,
        track_listing_preview_start_date: true,
      },
      created_at: "2025-02-05T08:04:10.000000Z",
      updated_at: "2025-02-05T08:20:48.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "21",
        type: 1,
        server: "3.82.143.185",
        password: "**********",
        username: "empire-test",
        directory: "supplychain",
        public_key: null,
        type_label: "FTP",
      },
    },
    {
      id: 228,
      name: "Amazon Dolby (TEST)",
      display_name: "Amazon Dolby (TEST)",
      image: "https://empiredi-sb-file.s3-accelerate.amazonaws.com/150.png",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 1,
      xml_version_label: "DDEX 3.8.2",
      uuid: "PADPIDAm6rmrzhe",
      options_attributes: {
        download: false,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: false,
        accepts_preorder: false,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: false,
        syndicates_ringtones: false,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: false,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: true,
        accepts_timed_releases: false,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: false,
        track_listing_preview_start_date: true,
      },
      created_at: "2025-02-05T08:12:29.000000Z",
      updated_at: "2025-02-05T08:20:57.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        port: "21",
        type: 1,
        server: "3.82.143.185",
        password: "**********",
        username: "empire-test",
        directory: "supplychain",
        public_key: null,
        type_label: "FTP",
      },
    },
    {
      id: 229,
      name: "Test Retailer DDEX",
      display_name: "Test Retailer DDEX",
      image: "https://empiredi-sb-file.s3-accelerate.amazonaws.com/150.png",
      notes: null,
      status: 1,
      status_label: "Active",
      website: null,
      xml_version: 1,
      xml_version_label: "DDEX 3.8.2",
      uuid: "PADPIDAm7xndqe1",
      options_attributes: {
        download: true,
        streaming: true,
        has_contract: true,
        royalty_only: false,
        uses_manifest: false,
        auto_syndicate: false,
        accepts_preorder: true,
        features_in_title: false,
        priority_retailer: false,
        syndicates_albums: true,
        syndicates_videos: true,
        syndicates_ringtones: true,
        unchecked_by_default: false,
        uses_specific_genres: false,
        accepts_preview_clips: true,
        allow_partial_uploads: false,
        included_in_analytics: false,
        accepts_dolby_products: true,
        accepts_timed_releases: true,
        auto_generate_manifest: false,
        clip_preview_start_date: true,
        auto_approve_syndication: false,
        allow_custom_album_pricing: false,
        allow_custom_track_pricing: false,
        release_display_start_date: true,
        cover_art_preview_start_date: true,
        included_in_analytic_details: false,
        track_listing_preview_start_date: true,
      },
      created_at: "2025-03-06T17:55:42.000000Z",
      updated_at: "2025-03-06T17:59:53.000000Z",
      queued: 0,
      running: 0,
      failed: 0,
      uploaded: 0,
      approved: 0,
      credentials: {
        type: 1,
        public_key: null,
        type_label: "FTP",
      },
    },
  ],
  parental_advisories: [
    {
      id: 1,
      title: "Explicit",
    },
    {
      id: 2,
      title: "Clean",
    },
    {
      id: 3,
      title: "Neither",
    },
  ],
  product_types: [
    {
      id: 1,
      name: "Album",
    },
    {
      id: 2,
      name: "Video",
    },
    {
      id: 4,
      name: "Ringtone",
    },
  ],
  main_product_types: [
    {
      id: 1,
      name: "Album",
    },
    {
      id: 2,
      name: "Video",
    },
    {
      id: 4,
      name: "Ringtone",
    },
  ],
  tooltips: [],
  billingTypes: [
    {
      id: "wire",
      title: "Wire",
    },
    {
      id: "sepa",
      title: "Sepa",
    },
  ],
  billingProviders: [
    {
      id: 1,
      title: "Bill.com",
    },
    {
      id: 2,
      title: "Circle.com",
    },
  ],
  salesTypes: [
    {
      id: 1,
      title: "Album",
    },
    {
      id: 2,
      title: "Video",
    },
    {
      id: 3,
      title: "Track",
    },
    {
      id: 4,
      title: "Ringtone",
    },
    {
      id: 5,
      title: "Audio Stream",
    },
    {
      id: 6,
      title: "Video Stream",
    },
  ],
};
